import { render, staticRenderFns } from "./v-person.vue?vue&type=template&id=1a2542d2&scoped=true&"
import script from "./v-person.vue?vue&type=script&lang=ts&"
export * from "./v-person.vue?vue&type=script&lang=ts&"
import style0 from "./v-person.vue?vue&type=style&index=0&id=1a2542d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2542d2",
  null
  
)

export default component.exports